import queryString from 'query-string';
import {buildPageUrl} from '../../../../utils';
import ignite from '../../../../services/ignite';
import getLogger from '@ignitesales/logger-es';

const logger = getLogger({ module: 'deepLinkUtil' });

const deepLinkCheckAndRedirect = async ({ onCheckComplete, paramName, pathMap, shouldUpdateAnswer, state }) => {
  let isRedirecting = false;
  const urlQuery = window.location.search;
  logger.debug('Checking for deep link', urlQuery);

  try {
    if (!pathMap) {
      logger.error('Unable to handle deep link, no pathMap configured');
    } else {
      const urlParamKey = paramName || 'path';
      const pathsToLookFor = Object.keys(pathMap);
      const parsed = queryString.parse(urlQuery);
      const pathParam = parsed[urlParamKey] || '';
      if (pathParam && pathsToLookFor.includes(pathParam)) {
        const pathMapValue = pathMap[pathParam];
        shouldUpdateAnswer && await _saveDeepLinkAnswers( pathMapValue, shouldUpdateAnswer );
        onCheckComplete && await onCheckComplete({ pathMapValue });

        const { user: { uuid } } = state;
        const redirectUrl = buildPageUrl({
          type: 'survey',
          uuid,
          path: { key: pathMapValue.path },
          page: { key: pathMapValue.page }
        });
        await ignite.answerService.saveAnswer({
          appkey: 'debug__deepLinkPathParam',
          value: pathParam,
          timestamp: new Date()
        });
        logger.debug('Redirecting via deep link', redirectUrl);
        window.location.href = redirectUrl;
        isRedirecting = true;
      } else {
        logger.debug('No deep link param matched');
      }
    }
  } catch (ex) {
    logger.error('Deep linking process failed', ex);
  }

  return isRedirecting;
};

const _saveDeepLinkAnswers = async ( pathMapValue, appkey ) => {
  logger.debug('Attempting to save answers for deep link param', pathMapValue);
  if( typeof appkey === 'string' ) {
    if( pathMapValue?.value ){
      const currentAppkeyAnswer = await ignite.answerService.getAnswer(appkey);
      const updatedAppkeyAnswer = pathMapValue?.overwrite || Array.isArray(pathMapValue?.value)
        ? pathMapValue?.value
        : [...(currentAppkeyAnswer?.value || []), pathMapValue.value ];
      await ignite.answerService.saveAnswer({
        appkey,
        value: updatedAppkeyAnswer,
        timestamp: new Date()
      });
    } else {
      logger.debug('No value present for deep link to save');
    }
  } else {
    logger.error('Unable to save deep link param answers, invalid appkey', appkey);
  }
};


export {
  deepLinkCheckAndRedirect
};
